// parent
jQuery(document).ready(function ($) {
    if (window.location.href.indexOf('boek-een-kamer/') > 0) {
        (function(history){
            var pushState = history.pushState;
            history.pushState = function(state, u, new_url) {
                // YOUR CUSTOM HOOK / FUNCTION
                $('.Welcome_tralala').remove();
                console.log(new_url.endsWith('boek-een-kamer/'));
                if (new_url.endsWith('boek-een-kamer/')) {
                    $('.rn-accommodation-search-form-section').show();
                    $('.wp-block-cover').show();
                } else {
                    $('.rn-accommodation-search-form-section').hide();
                    $('.wp-block-cover').hide();
                }
                return pushState.apply(history, arguments);
            };
        })(window.history);
    }

    // Smooth Scroll
    $(function () {
        $('a[href*="#"]:not([href="#"]):not(a.comment-reply-link):not([href="#tab-reviews"]):not([href="#tab-additional_information"]):not([href="#tab-description"]):not([href="#reviews"]):not([href="#carouselExampleIndicators"]):not([data-smoothscroll="false"]):not([data-bs-toggle="collapse"])').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html, body').animate({
                        // Change your offset according to your navbar height
                        scrollTop: target.offset().top - 260
                        //scrollspeed
                    }, 2000);
                    return !1
                }
            }
        })
    });


    var initializeBlock = function ($block) {
        $block.find('.slides').slick({
            dots: true,
            infinite: true,
            animation: "slide",
            autoplaySpeed: 3000,
            arrows: true,
            speed: 300,
            slidesToShow: 1,
            prevArrow: $block.find('.new_prev'),
            nextArrow: $block.find('.new_next'),
            centerMode: false,
            variableWidth: false,
            adaptiveHeight: false,
            focusOnSelect: false,
            autoplay: true,
            slidesToScroll: 1,
            touchThreshold: 1000
        });


    }

    $('.slider').each(function () {
        initializeBlock($(this));

    });
    // Initialize dynamic block preview (editor).
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=slider', initializeBlock);
    }

    //https://stackoverflow.com/questions/12558311/add-remove-class-with-jquery-based-on-vertical-scroll
    if ($('body.page,.blog').length >= 0) {//als body een page is of een blog
        var scroll = $(window).scrollTop();
        if (scroll >= 50) {
            $("#masthead").addClass("stickyHeader");
        } else {
            $("#masthead").removeClass("stickyHeader");
        }
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 50) {
                $("#masthead").addClass("stickyHeader");
            } else {
                $("#masthead").removeClass("stickyHeader");
            }
        });
    }

//----------Collapse-Button---------\\
    $('.collapse').on('show.bs.collapse', function () {
        var $parent = $('#' + $(this).data('parent'));
        $parent.addClass('show');
    });
    //---page scrolling---\\
    $('.collaapse').on('shown.bs.collapse', function () {
        var $parent = $('#' + $(this).data('parent'));
        $('html, body').animate({
            // Change your offset according to your navbar height
            scrollTop: $parent.offset().top - 116
        }, 200, 'swing')

    });
    //--------------------\\
    $('.collapse').on('hide.bs.collapse', function () {
        var $parent = $('#' + $(this).data('parent'));
        $parent.removeClass('show');
    });
//---page scrolling---\\
    $('.collaapse').on('hidden.bs.collapse', function () {
        var $parent = $('#' + $(this).data('parent'));
        $('html, body').animate({
            // Change your offset according to your navbar height
            scrollTop: $parent.offset().top - 116
        }, 10, 'swing')
    });
//------------------------------------------------


    $(function () {
        $('.scroll').on('click', function (e) {
            e.preventDefault();
            $('html, body').animate({
                // Change your offset according to your navbar height
                scrollTop: $($(this).attr('href')).offset().top - 260
            }, 1000, 'swing')
        });
        if (window.location.hash) {
            $('html, body').animate({
                // Change your offset according to your navbar height
                scrollTop: $(window.location.hash).offset().top - 260
            }, 1000, 'swing')
        }

    });


    // Scroll to top Button
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 500) {
            $(".top-button").addClass("visible");
        } else {
            $(".top-button").removeClass("visible");
        }
    });

    // Alert links
    $('.alert a').addClass('alert-link');

    // Wp-column set height
    $('.wp-block-column>h3').addClass('setHeight');


    // Temp Offcanvas
    // Freeze Body
    $('.navbar-toggler.right').on('click', function () {
        $('#offcanvas-menu-right').addClass('show')
        $('body').toggleClass('offcanvas-backdrop offcanvas-freeze offcanvas-open')
    });

    // Remove Freeze Body
    $('.offcanvas-header, .backdrop-overlay').on('click', function () {
        $('#offcanvas-menu-right').removeClass('show')
        $('body').removeClass('offcanvas-backdrop offcanvas-freeze offcanvas-open')
    });
    // Temp Offcanvas



    // Dropdown menu animation
    $('.dropdown-menu').addClass('invisible'); //FIRST TIME INVISIBLE

    // Add slidedown animation to dropdown open
    $('.dropdown').on('show.bs.dropdown', function (e) {
        $('.dropdown-menu').removeClass('invisible');
        $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    // Add slideup animation to dropdown close
    $('.dropdown').on('hide.bs.dropdown', function (e) {
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
    });


    // Close dropdown and offcanvas on click .dropdown .nav-link, keep .dropdown-menu open
    $('.navbar-nav>li>a:not(.dropdown-toggle), a.dropdown-item').on('click', function () {
        $('.offcanvas').removeClass('show')
        $('body').removeClass('offcanvas-backdrop offcanvas-freeze offcanvas-open')
    });

    // Close offcanvas, dropdown-menu and backdrop-overlay on resize
    window.onresize = function () {
        $('.offcanvas, .dropdown-menu').removeClass('show')
        $('body').removeClass('offcanvas-backdrop offcanvas-freeze offcanvas-open')
        $('.dropdown-menu').addClass('invisible')
    }


    // Mobile search button hide if empty
    if ($('.searchform').length != 1) {
        $('.top-nav-search-md, .top-nav-search-lg').addClass('hide');
    }
    if ($('.searchform').length != 0) {
        $('.top-nav-search-md, .top-nav-search-lg').removeClass('hide');
    }

    // Active menu item workaround, check navwalker when ready
    var url = window.location.pathname,
        urlRegExp = new RegExp(url.replace(/\/$/, '') + "$"); // create regexp to match current url pathname and remove trailing slash if present as it could collide with the link in navigation in case trailing slash wasn't present there
    // now grab every link from the navigation
    $('.nav-link').each(function () {
        // and test its normalized href against the url pathname regexp
        if (urlRegExp.test(this.href.replace(/\/$/, ''))) {
            $(this).addClass('active');
        }
    });
    // Remove active on frontpage
    if ($('body.home').length) {
        $('.nav-link').removeClass('active');
    }
    // Add active to nav-link if menu-item is active
    if ($('.current_page_item').hasClass('active')) {
        $('.current_page_item.active .nav-link').addClass('active');
    }
    if ($('.current-menu-item').hasClass('active')) {
        $('.current-menu-item.active .nav-link').addClass('active');
    }
    if ($('.current-post-ancestor').hasClass('active')) {
        $('.current-post-ancestor .nav-link').addClass('active');
    }
    if ($('.current_page_parent').hasClass('active')) {
        $('.current_page_parent .nav-link').addClass('active');
    }
    // Active menu item workaround End


}); // jQuery End
